import React, { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged, signInWithPopup, signOut } from "firebase/auth";
import { auth, provider } from "./firebase";
import translations from "./i18n/translations";
import Login from "./pages/Login";
import Browse from "./pages/Browse";
import PostListing from "./pages/PostListing";
import MyListings from "./pages/MyListings";
import ListingDetail from "./pages/ListingDetail";
import Profile from "./pages/Profile";
import BottomNav from "./components/BottomNav";
import "./App.css";

export const AppContext = createContext();

export function useApp() {
  return useContext(AppContext);
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState("en");
  const [showPost, setShowPost] = useState(false);

  const t = translations[lang];

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  const handleSignIn = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSignOut = async () => {
    await signOut(auth);
  };

  const toggleLang = () => setLang(l => l === "en" ? "pt" : "en");

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-logo">
  <svg width="64" height="64" viewBox="0 0 56 56" fill="none">
    <rect width="56" height="56" rx="14" fill="#1a2744"/>
    <rect x="13" y="13" width="13" height="13" rx="2" fill="#f0e6c8"/>
    <rect x="30" y="13" width="13" height="13" rx="2" fill="#f0e6c8"/>
    <rect x="13" y="30" width="13" height="13" rx="2" fill="#f0e6c8"/>
    <rect x="30" y="30" width="13" height="13" rx="2" fill="#c0392b"/>
  </svg>
</div>
      </div>
    );
  }

  return (
    <AppContext.Provider value={{ user, lang, t, toggleLang, handleSignOut, showPost, setShowPost }}>
      <Router>
        <div className="app-shell">
          {!user ? (
            <Login onSignIn={handleSignIn} />
          ) : (
            <>
              <Routes>
                <Route path="/" element={<Browse />} />
                <Route path="/listing/:id" element={<ListingDetail />} />
                <Route path="/my-listings" element={<MyListings />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
              {showPost && <PostListing onClose={() => setShowPost(false)} />}
              <BottomNav />
            </>
          )}
        </div>
      </Router>
    </AppContext.Provider>
  );
}

export default App;
